import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import './rich-text-editor.css';
import { normalizeDescriptionHtml } from '../utils/richText';

const TOOLBAR_OPTIONS = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  ['blockquote', 'link'],
  ['clean'],
];

export default function RichTextEditor({
  value = '',
  onChange,
  placeholder = 'Write product description...',
  disabled = false,
}) {
  const wrapperRef = useRef(null);
  const quillRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!wrapperRef.current || quillRef.current) return undefined;

    const editorEl = document.createElement('div');
    editorEl.className = 'rich-text-editor__canvas';
    wrapperRef.current.appendChild(editorEl);

    const quill = new Quill(editorEl, {
      theme: 'snow',
      placeholder,
      modules: { toolbar: TOOLBAR_OPTIONS },
    });

    quillRef.current = quill;

    if (value) {
      quill.clipboard.dangerouslyPasteHTML(normalizeDescriptionHtml(value));
    }

    quill.on('text-change', () => {
      onChangeRef.current(quill.root.innerHTML);
    });

    quill.enable(!disabled);

    return () => {
      quillRef.current = null;
      if (wrapperRef.current) {
        wrapperRef.current.innerHTML = '';
      }
    };
  }, []);

  useEffect(() => {
    const quill = quillRef.current;
    if (!quill) return;

    const currentHtml = quill.root.innerHTML;
    const nextHtml = normalizeDescriptionHtml(value || '');
    if (nextHtml !== currentHtml) {
      quill.clipboard.dangerouslyPasteHTML(nextHtml);
    }
  }, [value]);

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.enable(!disabled);
    }
  }, [disabled]);

  return (
    <div className={`rich-text-editor${disabled ? ' rich-text-editor--disabled' : ''}`}>
      <div ref={wrapperRef} />
    </div>
  );
}
